import { Locales } from 'types/locale';

import Model from 'models/Model';

import { select as selectLocale } from 'utils/locale';
import { changeFromCent, displayPrice } from 'utils/math';

import Plan from './Plan';
import { planFeaturesOptions } from './PlanFeatures';

const translationsModels = selectLocale({
    [Locales.Pl]: require('locales/models/pl.json'),
});

interface FeatureOption {
    id: string;
    label: string;
    value: boolean;
}

export default class FeatureList implements Model {
    id: string;
    price: number;
    priceDisplay: string;
    planPriceMonthly: string;
    planPriceYearly: string;
    name: string;
    description: string;
    active: boolean;
    options: FeatureOption[];

    constructor(data: Plan) {
        this.id = data.id;
        this.price = data.priceMonth;
        this.priceDisplay = displayPrice(changeFromCent(this.price));
        this.planPriceMonthly = displayPrice(changeFromCent(data.priceMonth));
        this.planPriceYearly = displayPrice(changeFromCent(data.priceYear));
        this.name = data.name;
        this.description = data.description || '';
        this.active = false;
        this.options = data.planFeatures && planFeaturesOptions.map(option => {
            const matchedFeature = data.planFeatures.some(feature => feature.feature === option.id);
            return {
                ...option,
                value: matchedFeature,
            };
        });
    }
}
